/**
 * API 配置
 * 从环境变量读取 API 地址和端口
 */
export const getApiBaseUrl = (): string => {
  return `https://dc.deepfate.ai/api`;
};

